// LoggoSelector.js

import React, { useEffect, useState } from "react";
import stadsloppet from "./stadsloppet.png";
import halligang from "./halligang.png";
import eagle from "./eagle.png";
import eagle2 from "./eagle2.png";
import ofi from "./ofi-logga.png";

import noLoggoSelected from "./noLoggo.png"; // Replace with your empty state image
import { Button, Grid, GridItem, Box } from "@chakra-ui/react";

const imageList = [
  { name: "noLoggoSelected", path: noLoggoSelected },
  { name: "stadsloppet", path: stadsloppet },
  { name: "halligang", path: halligang },
  { name: "eagle", path: eagle },
  { name: "ofi", path: ofi },
  { name: "eagle2", path: eagle2 },
  // Add more image objects as needed
];

export function loggoResolver(loggoName: string) {
  if (loggoName) {
    return imageList.find((img) => img.name == loggoName)?.path ?? eagle;
  }
  return undefined;
}

const LoggoSelector = (props: {
  onSelect: (selection: string | null) => void;
  initialSelection?: string | null;
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(
    props.initialSelection ?? null
  );
  const [showPicker, setShowPicker] = useState(false);

  useEffect(() => {
    props.onSelect(selectedImage);
  }, [selectedImage]);

  const handleImageClick = (
    image: { name: string; path: string },
    index: number
  ) => {
    if (index === 0) {
      // Clicked on the empty state, unselect any previous selection
      setSelectedImage(null);
    } else {
      setSelectedImage(image.name);
    }
    setShowPicker(false);
  };

  const handleMiniatureClick = () => {
    setSelectedImage(null);
    setShowPicker(true);
  };

  return (
    <div>
      {selectedImage ? (
        <div>
          <img
            src={loggoResolver(selectedImage)}
            alt="Selected Image"
            style={{ width: "25%", height: "auto", cursor: "pointer" }}
            onClick={handleMiniatureClick}
          />
        </div>
      ) : (
        <div>
          {showPicker ? (
            <Grid
              templateColumns="repeat(3, 1fr)"
              gap={4}
              border="2px solid #3498db"
              borderRadius="10px"
              padding="10px"
              background={"blue.50"}
            >
              {imageList.map((image, index) => (
                <GridItem key={index}>
                  <Box
                    borderWidth="2px"
                    borderRadius="lg"
                    overflow="hidden"
                    transition="transform 0.3s ease-in-out"
                    _hover={{ transform: "scale(1.1)" }}
                  >
                    <img
                      src={image.path}
                      alt={`Image ${image.name}`}
                      className={`image-item`}
                      onClick={() => handleImageClick(image, index)}
                      style={{
                        width: "100%",
                        height: "auto",
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                </GridItem>
              ))}
            </Grid>
          ) : (
            <Button colorScheme="teal" onClick={() => setShowPicker(true)}>
              Select Image
            </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default LoggoSelector;
